/**
 * Porta predefinita dell'API B2B in sviluppo locale.
 * In produzione Traefik fa routing senza porta esplicita.
 */
const DEFAULT_API_PORT_DEV = 3006;

/**
 * Base URL per le chiamate HTTP all'API.
 *
 * **Priorità:**
 * 1. `REACT_APP_API_URL` (build-time) — usare SEMPRE in produzione.
 * 2. Stesso host della pagina (produzione senza env = Traefik same-origin).
 * 3. Localhost con porta 3006 (sviluppo locale).
 *
 * **Produzione (Aruba / Traefik):**
 * - Build senza `REACT_APP_API_URL` (same-origin) oppure URL assoluto del sito
 *   (es. `https://agent.ilp-consulting.it`) — mai `/api` da solo.
 * - Traefik routerà `/api/*` al backend sulla rete Docker interna.
 *
 * **Sviluppo locale:**
 * - Backend su `http://127.0.0.1:3006` (PORT=3006 default in src/main.ts).
 * - Frontend dev server su porta 8400.
 */
function getBaseUrl(): string {
  const envUrl = process.env.REACT_APP_API_URL?.trim();

  // `/api` era un default errato in compose/CI: i service appendono già `/api/...`.
  if (envUrl === '/api') {
    return '';
  }

  if (envUrl) {
    return envUrl.replace(/\/$/, '');
  }

  if (typeof window !== 'undefined') {
    const { protocol, hostname } = window.location;
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

    if (!isLocalhost) {
      // Produzione senza REACT_APP_API_URL: same-origin (Traefik routing).
      // NON aggiungere porta — Traefik ascolta su 443, backend è interno.
      return `${protocol}//${hostname}`;
    }
  }

  // Build Docker prod (NODE_ENV=production, nessun window): URL relative same-origin.
  if (process.env.NODE_ENV === 'production') {
    return '';
  }

  // Sviluppo locale: backend su porta 3006
  return `http://127.0.0.1:${DEFAULT_API_PORT_DEV}`;
}

export const BASE_URL = getBaseUrl();
